/**
 * Banno back-office link for the "Enable online banking in Banno back office"
 * task (MacKenzie Mott life-ring report 2026-10-16; Bill: "make the URL a
 * setting that can be corrected; when unset show a message saying it needs to
 * be set and where").
 *
 * SystemSetting `links.bannoBackOfficeUrl` (seed 415, empty until an admin sets
 * it in Admin portal > Retail > Configuration > Settings). Read from the config
 * bundle's systemSettings (a key -> value map; the legacy row array is tolerated).
 */

export const BANNO_BACK_OFFICE_URL_KEY = 'links.bannoBackOfficeUrl';

export const BANNO_URL_NOT_SET_MESSAGE =
  "The Banno back office link hasn't been set. An administrator can set it in the Admin portal "
  + '(admin.mypcb.com) > Retail > Configuration > Settings > links.bannoBackOfficeUrl.';

function rawSetting(systemSettings: unknown, key: string): unknown {
  if (Array.isArray(systemSettings)) {
    for (const row of systemSettings as ReadonlyArray<Record<string, unknown>>) {
      if (!row || typeof row !== 'object') continue;
      const k = typeof row.settingKey === 'string' ? row.settingKey : typeof row.key === 'string' ? row.key : undefined;
      if (k === key) return row.settingValue ?? row.value;
    }
    return undefined;
  }
  if (systemSettings && typeof systemSettings === 'object') {
    return (systemSettings as Record<string, unknown>)[key];
  }
  return undefined;
}

/** The configured https/http URL, or '' when unset or not a web address. */
export function readBannoBackOfficeUrl(systemSettings: unknown): string {
  const v = rawSetting(systemSettings, BANNO_BACK_OFFICE_URL_KEY);
  if (typeof v !== 'string') return '';
  const url = v.trim();
  if (!url) return '';
  try {
    const u = new URL(url);
    return u.protocol === 'https:' || u.protocol === 'http:' ? url : '';
  } catch {
    return '';
  }
}
